import * as React from "react";
import {
  AppBar,
  Divider,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import smallLogo from "../../assets/icon-mark@2x.png";
import middleLogo from "../../assets/icon-mark@2x.png";
import largeLogo from "../../assets/icon-mark@2x.png";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../../contexts/SidebarContext";

type Props = {
  title?: string;
  handleDrawerToggle?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};
export const Header: React.FC<Props> = ({ title = "", handleDrawerToggle }) => {
  const navigate = useNavigate();
  const { isCollapsed, toggleSidebar } = useSidebar();
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: "#FFF",
        boxShadow: "0px 1px 3px rgba(0, 0, 0, .1)",
        maxHeight: "53px",
      }}
    >
      <Toolbar style={{ minHeight: "53px", maxHeight: "53px" }}>
        <Tooltip title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}>
          <IconButton
            color="inherit"
            aria-label="toggle sidebar"
            onClick={toggleSidebar}
            sx={{
              mr: 1,
              display: { xs: "none", sm: "inline-flex" },
              color: "#000",
              opacity: isCollapsed ? 1 : 0.5,
              transition: "opacity 0.2s ease",
            }}
          >
            <MenuIcon />
          </IconButton>
        </Tooltip>
        <Button
          onClick={(e) => {
            if (e.ctrlKey || e.metaKey) {
              window.open(window.location.origin, "_blank");
              return;
            }
            navigate("/");
          }}
          onMouseDown={(e) => {
            if (e.button === 1) {
              e.preventDefault();
              window.open(window.location.origin, "_blank");
            }
          }}
          style={{ backgroundColor: "transparent" }}
        >
          <Typography variant="h6" noWrap component="div">
            <img
              src={smallLogo}
              alt={"WriteAhead logo"}
              srcSet={`${smallLogo} 300w, ${middleLogo} 768w, ${largeLogo} 1280w`}
              width="44px"
              style={{ marginTop: "4px" }}
            />
          </Typography>
        </Button>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderRightWidth: 1 }}
          style={{
            marginLeft: "1em",
            marginTop: "0.5em",
            marginBottom: "0.5em",
            background: "#CCC",
          }}
        />
        <Typography
          variant="h1"
          noWrap
          component="div"
          style={{
            marginLeft: "1em",
            marginTop: "0.5em",
            marginBottom: "0.5em",
            color: "#413E3F",
          }}
        >
          {title}
        </Typography>
        <div style={{ flexGrow: "2", textAlign: "right" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" }, color: "#000" }}
          >
            <MenuIcon />
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
};
